import * as i0 from '@angular/core';
import * as i1 from './menu.module';
import * as i2 from '@angular/common';
import * as i3 from '@angular/forms';
import * as i4 from '@angular/router';
import * as i5 from './menu.component';
import * as i6 from '../shared/shared.module';
export const NbMenuModuleNgFactory:i0.NgModuleFactory<i1.NbMenuModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.ɵangular_packages_forms_forms_bh = (<any>(null as any));
var _decl0_12:i3.NgSelectOption = (<any>(null as any));
var _decl0_13:i3.ɵangular_packages_forms_forms_s = (<any>(null as any));
var _decl0_14:i3.DefaultValueAccessor = (<any>(null as any));
var _decl0_15:i3.ɵangular_packages_forms_forms_be = (<any>(null as any));
var _decl0_16:i3.ɵangular_packages_forms_forms_bg = (<any>(null as any));
var _decl0_17:i3.CheckboxControlValueAccessor = (<any>(null as any));
var _decl0_18:i3.SelectControlValueAccessor = (<any>(null as any));
var _decl0_19:i3.SelectMultipleControlValueAccessor = (<any>(null as any));
var _decl0_20:i3.RadioControlValueAccessor = (<any>(null as any));
var _decl0_21:i3.NgControlStatus = (<any>(null as any));
var _decl0_22:i3.NgControlStatusGroup = (<any>(null as any));
var _decl0_23:i3.RequiredValidator = (<any>(null as any));
var _decl0_24:i3.MinLengthValidator = (<any>(null as any));
var _decl0_25:i3.MaxLengthValidator = (<any>(null as any));
var _decl0_26:i3.PatternValidator = (<any>(null as any));
var _decl0_27:i3.CheckboxRequiredValidator = (<any>(null as any));
var _decl0_28:i3.EmailValidator = (<any>(null as any));
var _decl0_29:i3.NgModel = (<any>(null as any));
var _decl0_30:i3.NgModelGroup = (<any>(null as any));
var _decl0_31:i3.NgForm = (<any>(null as any));
var _decl0_32:i3.NgFormSelectorWarning = (<any>(null as any));
var _decl0_33:i4.RouterOutlet = (<any>(null as any));
var _decl0_34:i4.RouterLink = (<any>(null as any));
var _decl0_35:i4.RouterLinkWithHref = (<any>(null as any));
var _decl0_36:i4.RouterLinkActive = (<any>(null as any));
var _decl0_37:i4.ɵEmptyOutletComponent = (<any>(null as any));
var _decl0_38:i5.NbMenuComponent = (<any>(null as any));
var _decl0_39:i5.NbMenuItemComponent = (<any>(null as any));
var _decl0_40:i2.AsyncPipe = (<any>(null as any));
var _decl0_41:i2.UpperCasePipe = (<any>(null as any));
var _decl0_42:i2.LowerCasePipe = (<any>(null as any));
var _decl0_43:i2.JsonPipe = (<any>(null as any));
var _decl0_44:i2.SlicePipe = (<any>(null as any));
var _decl0_45:i2.DecimalPipe = (<any>(null as any));
var _decl0_46:i2.PercentPipe = (<any>(null as any));
var _decl0_47:i2.TitleCasePipe = (<any>(null as any));
var _decl0_48:i2.CurrencyPipe = (<any>(null as any));
var _decl0_49:i2.DatePipe = (<any>(null as any));
var _decl0_50:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_51:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_52:i2.KeyValuePipe = (<any>(null as any));
var _decl0_53:i6.NbSharedModule = (<any>(null as any));
var _decl0_54:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_55:i0.ElementRef<any> = (<any>(null as any));
function _View_NbMenuComponent_Host_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_38.inverseValue;
  currVal_0;
}
function _View_NbMenuComponent_1_2():void {
  if (!_any.hidden) {
    var _any:any = (null as any);
    const currVal_0:any = _any;
    currVal_0;
    const currVal_1:any = _any.group;
    currVal_1;
    const pd_2:any = ((<any>_decl0_38.onHoverItem(_any)) !== false);
    const pd_3:any = ((<any>_decl0_38.onToggleSubMenu(_any)) !== false);
    const pd_4:any = ((<any>_decl0_38.onSelectItem(_any)) !== false);
    const pd_5:any = ((<any>_decl0_38.onItemClick(_any)) !== false);
  }
}
function _View_NbMenuComponent_1_1():void {
  var _any:any = (null as any);
  const currVal_0:any = !_any.hidden;
  currVal_0;
}
function _View_NbMenuComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_38.items;
  currVal_0;
}
function _View_NbMenuItemComponent_Host_2_0():void {
  var _any:any = (null as any);
}
function _View_NbMenuItemComponent_2_2():void {
  if ((_decl0_39.menuItem.group && _decl0_39.menuItem.icon)) {
    var _any:any = (null as any);
    const currVal_0:any = i0.ɵinlineInterpolate(1,'menu-icon ',_decl0_39.menuItem.icon,
        '');
    currVal_0;
  }
}
function _View_NbMenuItemComponent_2_1():void {
  if (_decl0_39.menuItem.group) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_39.menuItem.icon;
    currVal_0;
    const currVal_1:any = _decl0_39.menuItem.title;
    currVal_1;
  }
}
function _View_NbMenuItemComponent_2_4():void {
  if (((((_decl0_39.menuItem.link && !_decl0_39.menuItem.url) && !_decl0_39.menuItem.children) && !_decl0_39.menuItem.group) && _decl0_39.menuItem.icon)) {
    var _any:any = (null as any);
    const currVal_0:any = i0.ɵinlineInterpolate(1,'menu-icon ',_decl0_39.menuItem.icon,
        '');
    currVal_0;
  }
}
function _View_NbMenuItemComponent_2_3():void {
  if ((((_decl0_39.menuItem.link && !_decl0_39.menuItem.url) && !_decl0_39.menuItem.children) && !_decl0_39.menuItem.group)) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_39.menuItem.queryParams;
    currVal_0;
    const currVal_1:any = _decl0_39.menuItem.fragment;
    currVal_1;
    const currVal_2:any = _decl0_39.menuItem.link;
    currVal_2;
    const currVal_3:any = _decl0_35.target;
    currVal_3;
    const currVal_4:any = _decl0_35.href;
    currVal_4;
    const currVal_5:any = _decl0_39.menuItem.target;
    currVal_5;
    const currVal_6:any = _decl0_39.menuItem.title;
    currVal_6;
    const currVal_7:any = _decl0_39.menuItem.selected;
    currVal_7;
    const currVal_8:any = _decl0_39.menuItem.icon;
    currVal_8;
    const currVal_9:any = _decl0_39.menuItem.title;
    currVal_9;
    const pd_10:any = ((<any>_decl0_35.onClick(_any.button,_any.ctrlKey,_any.metaKey,
        _any.shiftKey)) !== false);
    const pd_11:any = ((<any>_decl0_39.onHoverItem(_decl0_39.menuItem)) !== false);
    const pd_12:any = ((<any>_decl0_39.onItemClick(_decl0_39.menuItem)) !== false);
  }
}
function _View_NbMenuItemComponent_2_6():void {
  if (((((_decl0_39.menuItem.url && !_decl0_39.menuItem.children) && !_decl0_39.menuItem.link) && !_decl0_39.menuItem.group) && _decl0_39.menuItem.icon)) {
    var _any:any = (null as any);
    const currVal_0:any = i0.ɵinlineInterpolate(1,'menu-icon ',_decl0_39.menuItem.icon,
        '');
    currVal_0;
  }
}
function _View_NbMenuItemComponent_2_5():void {
  if ((((_decl0_39.menuItem.url && !_decl0_39.menuItem.children) && !_decl0_39.menuItem.link) && !_decl0_39.menuItem.group)) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_39.menuItem.url;
    currVal_0;
    const currVal_1:any = _decl0_39.menuItem.target;
    currVal_1;
    const currVal_2:any = _decl0_39.menuItem.title;
    currVal_2;
    const currVal_3:any = _decl0_39.menuItem.selected;
    currVal_3;
    const currVal_4:any = _decl0_39.menuItem.icon;
    currVal_4;
    const currVal_5:any = _decl0_39.menuItem.title;
    currVal_5;
    const pd_6:any = ((<any>_decl0_39.onHoverItem(_decl0_39.menuItem)) !== false);
    const pd_7:any = ((<any>_decl0_39.onSelectItem(_decl0_39.menuItem)) !== false);
  }
}
function _View_NbMenuItemComponent_2_8():void {
  if (((((!_decl0_39.menuItem.children && !_decl0_39.menuItem.link) && !_decl0_39.menuItem.url) && !_decl0_39.menuItem.group) && _decl0_39.menuItem.icon)) {
    var _any:any = (null as any);
    const currVal_0:any = i0.ɵinlineInterpolate(1,'menu-icon ',_decl0_39.menuItem.icon,
        '');
    currVal_0;
  }
}
function _View_NbMenuItemComponent_2_7():void {
  if ((((!_decl0_39.menuItem.children && !_decl0_39.menuItem.link) && !_decl0_39.menuItem.url) && !_decl0_39.menuItem.group)) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_39.menuItem.target;
    currVal_0;
    const currVal_1:any = _decl0_39.menuItem.title;
    currVal_1;
    const currVal_2:any = _decl0_39.menuItem.selected;
    currVal_2;
    const currVal_3:any = _decl0_39.menuItem.icon;
    currVal_3;
    const currVal_4:any = _decl0_39.menuItem.title;
    currVal_4;
    const pd_5:any = ((<any>_decl0_39.onHoverItem(_decl0_39.menuItem)) !== false);
    _any.preventDefault();
    const pd_6:any = ((<any>_decl0_39.onItemClick(_decl0_39.menuItem)) !== false);
  }
}
function _View_NbMenuItemComponent_2_10():void {
  if ((_decl0_39.menuItem.children && _decl0_39.menuItem.icon)) {
    var _any:any = (null as any);
    const currVal_0:any = i0.ɵinlineInterpolate(1,'menu-icon ',_decl0_39.menuItem.icon,
        '');
    currVal_0;
  }
}
function _View_NbMenuItemComponent_2_9():void {
  if (_decl0_39.menuItem.children) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_39.menuItem.target;
    currVal_0;
    const currVal_1:any = _decl0_39.menuItem.title;
    currVal_1;
    const currVal_2:any = _decl0_39.menuItem.selected;
    currVal_2;
    const currVal_3:any = _decl0_39.menuItem.icon;
    currVal_3;
    const currVal_4:any = _decl0_39.menuItem.title;
    currVal_4;
    const currVal_5:any = !_decl0_39.menuItem.expanded;
    currVal_5;
    const currVal_6:any = _decl0_39.menuItem.expanded;
    currVal_6;
    _any.preventDefault();
    const pd_7:any = ((<any>_decl0_39.onToggleSubMenu(_decl0_39.menuItem)) !== false);
    const pd_8:any = ((<any>_decl0_39.onHoverItem(_decl0_39.menuItem)) !== false);
  }
}
function _View_NbMenuItemComponent_2_13():void {
  if ((_decl0_39.menuItem.children && !_any.hidden)) {
    var _any:any = (null as any);
    const currVal_0:any = _any;
    currVal_0;
    const currVal_1:any = _any.group;
    currVal_1;
    const pd_2:any = ((<any>_decl0_39.onHoverItem(_any)) !== false);
    const pd_3:any = ((<any>_decl0_39.onToggleSubMenu(_any)) !== false);
    const pd_4:any = ((<any>_decl0_39.onSelectItem(_any)) !== false);
    const pd_5:any = ((<any>_decl0_39.onItemClick(_any)) !== false);
  }
}
function _View_NbMenuItemComponent_2_12():void {
  if (_decl0_39.menuItem.children) {
    var _any:any = (null as any);
    const currVal_0:any = !_any.hidden;
    currVal_0;
  }
}
function _View_NbMenuItemComponent_2_11():void {
  if (_decl0_39.menuItem.children) {
    var _any:any = (null as any);
    const currVal_0:any = !(_decl0_39.menuItem.children && _decl0_39.menuItem.expanded);
    currVal_0;
    const currVal_1:any = _decl0_39.menuItem.expanded;
    currVal_1;
    const currVal_2:any = _decl0_39.toggleState;
    currVal_2;
    const currVal_3:any = _decl0_39.menuItem.children;
    currVal_3;
  }
}
function _View_NbMenuItemComponent_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_39.menuItem.group;
  currVal_0;
  const currVal_1:any = (((_decl0_39.menuItem.link && !_decl0_39.menuItem.url) && !_decl0_39.menuItem.children) && !_decl0_39.menuItem.group);
  currVal_1;
  const currVal_2:any = (((_decl0_39.menuItem.url && !_decl0_39.menuItem.children) && !_decl0_39.menuItem.link) && !_decl0_39.menuItem.group);
  currVal_2;
  const currVal_3:any = (((!_decl0_39.menuItem.children && !_decl0_39.menuItem.link) && !_decl0_39.menuItem.url) && !_decl0_39.menuItem.group);
  currVal_3;
  const currVal_4:any = _decl0_39.menuItem.children;
  currVal_4;
  const currVal_5:any = _decl0_39.menuItem.children;
  currVal_5;
}
